import { http } from "./http";

/** Overview row mirroring BlacklistOverviewItemDto. */
export interface BlacklistListItem {
  blacklistId: number;
  description: string;
  number: string;
  ani: string;
  blockedTill: string;
  isHidden: boolean;
}

export interface BlacklistListResponse {
  items: BlacklistListItem[];
}

/** Detail surface of a single blacklist (matches BlacklistDetailDto). */
export interface BlacklistDetail {
  blacklistId: number;
  description: string;
  dnisId?: number | null;
  aniDisplay: string;
  blockedTill: string;
  isHidden: boolean;
}

export interface BlacklistUpdatePayload {
  description: string;
  dnisId?: number | null;
  aniDisplay: string;
  blockedTill: string;
}

/** DNIS option for the "Apply to number" dropdown on the edit screen. */
export interface BlacklistDnisOption {
  dnisId: number;
  dnisPresentation: string;
}

export interface BlacklistDnisOptionResponse {
  items: BlacklistDnisOption[];
}

export const blacklistsApi = {
  list: (options?: { includeExpired?: boolean }) =>
    http<BlacklistListResponse>(
      `/api/blacklists${options?.includeExpired ? "?includeExpired=true" : ""}`,
    ),
  get: (blacklistId: number) =>
    http<BlacklistDetail>(`/api/blacklists/${blacklistId}`),
  create: () =>
    http<BlacklistDetail>("/api/blacklists", { method: "POST" }),
  update: (blacklistId: number, payload: BlacklistUpdatePayload) =>
    http<BlacklistDetail>(`/api/blacklists/${blacklistId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  delete: (blacklistId: number) =>
    http<void>(`/api/blacklists/${blacklistId}`, { method: "DELETE" }),
  dnisOptions: () =>
    http<BlacklistDnisOptionResponse>("/api/blacklists/options/dnis"),
};
